"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFormItem = exports.ContainerForm = void 0;
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const mobileWidth = '992px';
exports.ContainerForm = (0, styled_components_1.default)(antd_1.Form) `
  @media (max-width: ${mobileWidth}) {
    span {
      font-size: 16px;
    }
  }
`;
exports.StyledFormItem = (0, styled_components_1.default)(antd_1.Form.Item) `
  width: 100%;
`;
